import React, { Component } from 'react';
import creditCards from '../../images/credit-cards.png';
import spinner from '../../images/loading-spinner.gif';
import { translate } from 'react-i18next';
import TypeOfCard from '../../components/TypeOfCard';
import Input from '../../components/Input';

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldsValid: {
      }
    }
    this.handleValidate = this.handleValidate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleValidate({name, isValid}) {
    this.setState({
      fieldsValid: {
        ...this.state.fieldsValid,
        [name]: isValid
      }
    })
  }

  handleSubmit(e) {
    if (Object.values(this.state.fieldsValid).every(isValid => isValid)) {
      return this.props.handlePaymentSubmit(e);
    } else {
      e.preventDefault();
      // alert('Por favor llene todos los campos')
    }
  }

  render() {
    const isMember = false;
    const { t } = this.props;
    return (
      <div className="jumbotron panel-resvations panel-payment">
        <h4 className="page-header text-primary">
          <strong>{t('dashboard.room_payment.heading_userinfo')}</strong>
        </h4>
        <form method="post" onSubmit={this.handleSubmit}>
          <fieldset>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <Input
                  name="email"
                  onValidate={this.handleValidate}
                    onChange={this.props.handleEmailChange}
                    placeholder={t('dashboard.room_payment.holder_email')}
                    required={true}
                    type="email"
                    value={this.props.email} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <Input
                    name="name"
                    onValidate={this.handleValidate}
                    onChange={this.props.handleNameChange}
                    placeholder={t('dashboard.room_payment.holder_name')}
                    required={true}
                    type="text"
                    value={this.props.name} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <Input
                    name="lastname"
                    onValidate={this.handleValidate}
                    onChange={this.props.handleLastnameChange}
                    placeholder={t('dashboard.room_payment.holder_lastname')}
                    required={true}
                    type="text"
                    value={this.props.lastname} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <Input
                    name="phone"
                    onValidate={this.handleValidate}
                    onChange={this.props.handlePhoneChange}
                    placeholder={t('dashboard.room_payment.holder_phone')}
                    required
                    type="tel"
                    value={this.props.phone} />
                </div>
              </div>
              {this.props.RoomBook ? (
                <div className="col-sm-6">
                  <div className="form-group">
                    <Input
                      name="reservationOccupancy"
                      onValidate={this.handleValidate}
                      onChange={this.props.handleReservationOccupancy}
                      placeholder={t('dashboard.room_payment.holder_occupancy')}
                      required
                      type="number"
                      value={this.props.reservationOccupancy} />
                  </div>
                </div>
              ) : null}
              {this.props.RoomBook ? (
                <div className="col-sm-12">
                  <div className="form-group">
                    <Input
                      name="reservationtitle"
                      onValidate={this.handleValidate}
                      onChange={this.props.handleReservationTitle}
                      placeholder={t('dashboard.room_payment.holder_restitle')}
                      required
                      type="text"
                      value={this.props.reservationTitle} />
                  </div>
                </div>
              ) : null}
            </div>
            <div className="">
              <div className="form-group">
                <img
                  className={this.props.isPaying ? "" : "hidden"}
                  width="45px"
                  height="45px"
                  alt={t('dashboard.room_payment.img_spinner')}
                  src={spinner} />
              </div>
            </div>
            <div className={isMember ? "hidden" : ""}>
              <h4 className="page-header text-primary">
                <strong>{t('dashboard.room_payment.heading_payment')}</strong>
              </h4>
              <div className="row">
                <div className="col-xs-12">
                  <div className="form-group">
                    <Input
                      name="cardName"
                      onValidate={this.handleValidate}
                      onChange={this.props.handleCardName}
                      placeholder={t('dashboard.room_payment.holder_cname')}
                      required={!isMember}
                      type="text"
                      value={this.props.cardName ? this.props.cardName : ""} />
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="form-group">
                    <Input
                      name="cardNumber"
                      onValidate={this.handleValidate}
                      maxLength="19"
                      onChange={this.props.handleCardNumber}
                      placeholder={t('dashboard.room_payment.holder_cnumber')}
                      required={!isMember}
                      type="text"
                      value={this.props.cardNumber} />
                    <TypeOfCard number={this.props.cardNumber} />
                  </div>
                </div>
                <div className="col-xs-4">
                  <div className="form-group">
                    <Input
                      name="cardMonth"
                      onValidate={this.handleValidate}
                      max="12"
                      min="1"
                      onChange={this.props.handleCardMonth}
                      placeholder={t('dashboard.room_payment.holder_cmonth')}
                      required={!isMember}
                      type="number"
                      value={this.props.cmonth} />
                  </div>
                </div>
                <div className="col-xs-4">
                  <div className="form-group">
                    <Input
                      name="cardYear"
                      onValidate={this.handleValidate}
                      max="99"
                      min="19"
                      onChange={this.props.handleCardYear}
                      placeholder={t('dashboard.room_payment.holder_cyear')}
                      required={!isMember}
                      type="number"
                      value={this.props.cyear} />
                  </div>
                </div>
                <div className="col-xs-4">
                  <div className="form-group">
                    <Input
                      name="cardCvc"
                      onValidate={this.handleValidate}
                      maxLength="4"
                      onChange={this.props.handleCardCvc}
                      placeholder={t('dashboard.room_payment.holder_cvc')}
                      required={!isMember}
                      type="number"
                      value={this.props.cvc} />
                  </div>
                </div>
                <div className="col-xs-12">
                  <p>
                    <small className="text-muted">
                      {t('dashboard.room_payment.security')}
                    </small>
                  </p>
                </div>
                <div className="col-xs-12">
                  <div className="form-group">
                    <Input
                      name="streetAddress"
                      onValidate={this.handleValidate}
                      onChange={this.props.handleStreetChange}
                      placeholder={t('dashboard.room_payment.holder_street')}
                      required={!isMember}
                      type="text"
                      value={this.props.street ? this.props.street : ""} />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-8">
                  <div className="form-group">
                    <Input
                      name="neighborhood"
                      onValidate={this.handleValidate}
                      onChange={this.props.handleNeighborhoodChange}
                      placeholder={t('dashboard.room_payment.holder_neighborhood')}
                      required={!isMember}
                      type="text"
                      value={this.props.neighborhood ? this.props.neighborhood : ""} />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <div className="form-group">
                    <Input
                      name="postalCode"
                      onValidate={this.handleValidate}
                      onChange={this.props.handlePoChange}
                      placeholder={t('dashboard.room_payment.holder_po')}
                      required={!isMember}
                      type="number"
                      value={this.props.po ? this.props.po : ""} />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-8">
                  <div className="form-group">
                    <Input
                      name="city"
                      onValidate={this.handleValidate}
                      onChange={this.props.handleCityChange}
                      placeholder={t('dashboard.room_payment.holder_city')}
                      required={!isMember}
                      type="text"
                      value={this.props.city ? this.props.city : ""} />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <div className="form-group">
                    <Input
                      name="state"
                      onValidate={this.handleValidate}
                      onChange={this.props.handleStateChange}
                      placeholder={t('dashboard.room_payment.holder_state')}
                      required={!isMember}
                      type="text"
                      value={this.props.state ? this.props.state : ""} />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <div className="form-group">
                    <Input
                      name="country"
                      onValidate={this.handleValidate}
                      onChange={this.props.handleCountryChange}
                      placeholder={t('dashboard.room_payment.holder_country')}
                      required={!isMember}
                      type="text"
                      value={this.props.country ? this.props.country : ""} />
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="form-group">
                    <div className="checkbox">
                      <label>
                        <input
                          required={!isMember}
                          type="checkbox"
                          value="" />
                        {t('dashboard.room_payment.terms')}
                      </label>
                    </div>
                  </div>
                  {this.props.cowork ? (
                    <div className="form-group">
                      <div className="checkbox">
                        <label>
                          <input
                            onClick={this.props.handleFacturaChange}
                            type="checkbox" />
                          Require Factura
                        </label>
                      </div>
                    </div>
                  ) : null}
                  {this.props.is_factura ? (
                    <label>
                      Para poder enviarle su factura agradecemos compartir su cédula de situación fiscal al correo: ventasenlinea@iosoffices.com
                    </label>
                  ) : null}
                </div>
                <div className="col-xs-12">
                  <div className={this.props.error ? "" : "hidden"}>
                    <div className="alert alert-warning">
                      <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                      {this.props.error}
                    </div>
                  </div>
                </div>
                <div className="col-xs-6">
                  <div className="form-group">
                    <button
                      className="btn btn-primary btn-full-width"
                      disabled={this.props.isPaying}
                      type="submit">
                      {t('dashboard.room_payment.btn_pay')}
                    </button>
                    <img
                      className={this.props.isPaying ? "" : "hidden"}
                      width="45px"
                      height="45px"
                      alt={t('dashboard.room_payment.img_spinner')}
                      src={spinner} />
                  </div>
                </div>
                <div className="col-xs-6 text-right">
                  <img alt={t('dashboard.room_payment.img_credit')} width="150px" src={creditCards} />
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
}

export default translate('common')(Payment);



// WEBPACK FOOTER //
// ./src/store/Payment/Payment.js